import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { IconButtonProps as MuiIconButtonProps } from "@mui/material";
import { IconButton } from "../../components";

export const DeleteIconButton = (
  props: MuiIconButtonProps & {
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
    disabled?: boolean;
  }
) => {
  const { onClick, disabled, ...rest } = props;

  return (
    <IconButton onClick={onClick} disabled={disabled} color="error" size="small" {...rest}>
      <DeleteOutlineOutlinedIcon />
    </IconButton>
  );
};
